import loaders from './index'

export default class Engine {
    constructor(dist, includes) {
        this.dist = dist
        this.loaders = loaders
        this.fallbackLoaders = {}

        this.includes = includes
    }

    registerLoader(match, fn) {
        this.loaders[match] = fn
    }

    registerFallbackLoader(match, fn) {
        this.fallbackLoaders[match] = fn
    }

    require(path) {
        try {
            // get extension
            let parts = path.split(".")
            let ext = parts[parts.length - 1]
            let node = this.dist[path] || null

            if (!node) {
                for (let loader in this.fallbackLoaders) {
                    let re = new RegExp(loader)
                    if (re.test(ext)) {
                        return this.fallbackLoaders[loader](path)
                    }
                }

                return;
            }

            for (let loader in this.loaders) {
                let re = new RegExp(loader)
                if (re.test(ext)) {
                    return this.loaders[loader](node, this.includes)
                }
            }
        } catch (err) {
            throw new Error(`Failed to import module ${path}: ${err.message}`)
        }
    }
}